export const ACTIVE_OUTLET_STORAGE_KEY = "akas_active_outlet_id";
export const ACTIVE_OUTLET_DETAIL_STORAGE_KEY = "akas_active_outlet";

export const getActiveOutletId = () => {
  try {
    const value = Number(window.localStorage.getItem(ACTIVE_OUTLET_STORAGE_KEY));
    return Number.isInteger(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
};

export const setActiveOutlet = (outlet) => {
  if (!outlet?.id) return;

  window.localStorage.setItem(ACTIVE_OUTLET_STORAGE_KEY, String(outlet.id));
  window.localStorage.setItem(ACTIVE_OUTLET_DETAIL_STORAGE_KEY, JSON.stringify(outlet));
};

export const clearActiveOutlet = () => {
  window.localStorage.removeItem(ACTIVE_OUTLET_STORAGE_KEY);
  window.localStorage.removeItem(ACTIVE_OUTLET_DETAIL_STORAGE_KEY);
};

export const synchronizeActiveOutlet = (profile) => {
  const outlets = Array.isArray(profile?.outlets) ? profile.outlets : [];
  if (!outlets.length) return null;

  const storedId = getActiveOutletId();
  const active = outlets.find((outlet) => Number(outlet.id) === storedId)
    || outlets.find((outlet) => Number(outlet.id) === Number(profile?.current_outlet_id))
    || outlets[0];
  setActiveOutlet(active);
  return active;
};
